import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BestSelling from "@/assets/Best_Selling.png";
import ThirdParty from "@/assets/Third_Party_Items.png";
import {
  ProductContainer,
  ImageTextWrapper,
  StyledImage,
  StyledText,
  FlexContainer,
} from "./styles";

const ProductsDropdown = ({ onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    if (location.pathname === path) {
      // If already on the page, just close the dropdown
      onClose();
    } else {
      navigate(path);
      onClose();
    }
  };

  return (
    <ProductContainer>
      <FlexContainer>
        <ImageTextWrapper onClick={() => handleNavigation("/best-selling-products")}>
          <StyledImage preview={false} width={100} src={BestSelling} />
          <StyledText>Best Selling Items</StyledText>
        </ImageTextWrapper>
        <ImageTextWrapper onClick={() => handleNavigation("/third-party-products")}>
          <StyledImage preview={false} width={100} src={ThirdParty} />
          <StyledText>Third party Items</StyledText>
        </ImageTextWrapper>
        {/* <ImageTextWrapper>
          <StyledImage preview={false} width={100} src={PrivateSource} />
          <StyledText>Private Sourcing</StyledText>
        </ImageTextWrapper> */}
      </FlexContainer>
    </ProductContainer>
  );
};

export default ProductsDropdown;
